import { render, staticRenderFns } from "./examResult.vue?vue&type=template&id=4827d416&scoped=true"
import script from "./examResult.vue?vue&type=script&lang=js"
export * from "./examResult.vue?vue&type=script&lang=js"
import style0 from "./examResult.vue?vue&type=style&index=0&id=4827d416&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827d416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4827d416')) {
      api.createRecord('4827d416', component.options)
    } else {
      api.reload('4827d416', component.options)
    }
    module.hot.accept("./examResult.vue?vue&type=template&id=4827d416&scoped=true", function () {
      api.rerender('4827d416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/meredu/components/examResult.vue"
export default component.exports